import Icon from '../components/Icon.vue'

Icon.register({
  'chess-queen': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M436 512h-360c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12zM255.6 0c30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56 25.1-56 56-56zM460.1 154.6l39.4 20.8c3.5 1.9 6.4 6.6 6.4 10.6 0 1.3-0.4 3.3-0.9 4.5l-105 257.4h-288l-105-257.4c-0.5-1.2-0.9-3.2-0.9-4.5 0-4 2.9-8.7 6.4-10.6l39.2-20.7c5.6-3 12.6-1 15.9 4.5 10.6 17.8 23.7 38 44.4 38 28.8 0 30.6-19.9 31.7-57.5 0.2-6.5 5.5-11.7 12-11.7h41c5.2 0 9.8 3.3 11.4 8.2 8.9 26.7 26.1 41 47.9 41s39-14.3 47.9-41c1.6-4.9 6.2-8.2 11.4-8.2h41c6.5 0 11.8 5.2 12 11.7 1.1 37.7 3 57.5 31.7 57.5 21.3 0 35.4-22.3 44.1-37.8 3.2-5.7 10.3-7.8 16.1-4.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/chess-queen.js
// module id = null
// module chunks = 